<template>
  <div class="default-template">
    <div class="default-template__ttl">{{ question.question }}</div>
    <div class="default-template__sub-ttl"></div>
    <ul class="default-template__list">
      <li
        class="default-template__item"
        v-for="answer in question.answers"
        :key="answer.id"
        answer
        @click.prevent="select(answer.text)"
        :class="{ active: answerText === answer.text }"
      >
        {{ answer.text }}
      </li>
    </ul>
    <div class="main__action">
      <button class="btn btn--grey" @click.prevent="back">Back</button>
      <button class="btn" @click.prevent="next">Next</button>
    </div>
  </div>
</template>
<script>
export default {
  name: "QuestionTemplate",
  props: {
    question: Object,
    answers: Object,
  },
  data() {
    return {
      answerText: "",
    };
  },
  watch: {
    question: {
      immediate: true,
      handler(val) {
        if (this.answers[val.id]) {
          this.answerText = this.answers[val.id].val;
        } else {
          this.answerText = "";
        }
      },
    },
  },
  methods: {
    select(answer) {
      this.answerText = answer;
    },
    next() {
      if (this.answerText === "") return;
      const answer = {
        id: this.question.id,
        val: this.answerText,
        ttl: this.question.question,
      };
      this.$emit("next", answer);
    },
    back() {
      this.$emit("back");
    },
  },
};
</script>
